var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"countdown"},[(_vm.run)?[_vm._v("\n    "+_vm._s(_vm.frontText)+"\n    "),_c('i',{staticClass:"countdown__count"},[_vm._v(_vm._s(_vm.countNum))]),_vm._v("\n    "+_vm._s(_vm.afterText)+"\n  ")]:_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }